import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { IWardDTO, defaultWard } from '../../../interface/VaccinationInterface';
import { Modal } from 'react-bootstrap';
import { addToast } from '../../../utils/toastNotifications';
import { isFormValidated } from '../../../utils/formUtils';

const AddWardModal = ({
  show,
  close,
  addWardData,
}: {
  show: boolean;
  close: Function;
  addWardData?: Function;
}) => {
  const [wardData, setWardData] = useState<IWardDTO>(defaultWard);

  const handleFormChange = (input: string) => (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setWardData({
      ...wardData,
      [input]: value,
    });
  };

  const addWard = (event: FormEvent) => {
    if (!isFormValidated('ward-modal')) {
      return;
    }
    event.preventDefault();

    if (addWardData) {
      addWardData(wardData);
      addToast('Bio Data added', 'success');
      setWardData(defaultWard);
    }
  };

  useEffect(() => {
    if (show) {
      setWardData(defaultWard);
    }
  }, [show]);

  return (
    <Modal className='font-utile' centered show={show} onHide={() => close()} backdrop={'static'}>
      <form id='ward-modal'>
        <Modal.Header closeButton>
          <Modal.Title>Add Female Child Bio Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='form-group mt-3'>
            <label className='fw-600'>Age of child</label>
            <label htmlFor='ward-0' className='label-section rounded-1 p-3 mt-2'>
              <div className='form-check'>
                <input
                  type='radio'
                  className='form-check-input'
                  name='age-range'
                  checked={wardData.ageRange === '9 - 11'}
                  onChange={handleFormChange('ageRange')}
                  value={'9 - 11'}
                  id='ward-0'
                />
                <label className='form-check-label' htmlFor='ward-0'>
                  9 - 11 years
                </label>
              </div>
            </label>
            <label htmlFor='ward-1' className='label-section rounded-1 p-3 mt-2'>
              <div className='form-check'>
                <input
                  type='radio'
                  name='age-range'
                  className='form-check-input'
                  checked={wardData.ageRange === '12 - 14'}
                  value={'12 - 14'}
                  onChange={handleFormChange('ageRange')}
                  id='ward-1'
                />
                <label className='form-check-label' htmlFor='ward-1'>
                  12 - 14 years
                </label>
              </div>
            </label>
            <label htmlFor='ward-2' className='label-section rounded-1 p-3 mt-2'>
              <div className='form-check'>
                <input
                  type='radio'
                  value={'15 - 17'}
                  name='age-range'
                  className='form-check-input'
                  checked={wardData.ageRange === '15 - 17'}
                  onChange={handleFormChange('ageRange')}
                  id='ward-2'
                />
                <label className='form-check-label' htmlFor='ward-2'>
                  15 - 17 years
                </label>
              </div>
            </label>
          </div>
          <div>
            <label className='fw-600 mt-4'>School Attendance</label>
            <label htmlFor='ward-3' className='label-section rounded-1 p-3 mt-1'>
              <div className='form-check'>
                <input
                  type='checkbox'
                  className='form-check-input'
                  checked={wardData.isAttendingSchool}
                  onChange={handleFormChange('isAttendingSchool')}
                  id='ward-3'
                />
                <label className='form-check-label' htmlFor='ward-3'>
                  Does this child attend school ?
                </label>
              </div>
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className='btn btn-secondary text-white vitals-bg-primary'
            type='submit'
            onClick={addWard}
          >
            Add Bio Data
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default AddWardModal;
